import script from "./ProgramDetailStagesSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramDetailStagesSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramDetailStagesSidebar.vue?vue&type=style&index=0&id=6e544c78&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e544c78"]])

export default __exports__